import { post, get } from 'services/client';
import { apiEndpoints } from 'config';

export default {
  upload: (file, type) => {
    const data = new FormData();
    data.append('file', file);
    let url = apiEndpoints.fileUpload;
    if (type) {
      url += `?type=${type}`;
    }
    const options = {
      url,
      data,
      headers: {
        'Content-type': 'multipart/form-data',
      },
    };
    return post(options);
  },
  getTemplates: async folder => {
    const options = {
      url: apiEndpoints.templates,
      params: { folder },
    };
    return get(options);
  },
  getDefaultWineImage: async () => {
    const options = {
      url: apiEndpoints.defaultWineImage,
    };
    return get(options);
  },
  getWineImportTemplate: async () => {
    const options = {
      url: apiEndpoints.wineImportTemplate,
    };
    return get(options);
  },
};
